import { Fields } from "../../types/SchemaFactory";
import { TFunction } from "i18next";
import { schemaFactory } from "./../SchemaFactory";
import { UserForm } from "../../domain/models/dto/UserDTO";
import { phoneInfoFields } from "./../PhoneInfoSchema";
import { InitialPhone } from "../../domain/models/Phone";
import { addressFieldsFactory } from "../AddressSchema";

export const userProfileFields: Fields<UserForm> = {
    firstName: {
        min: 2,
        max: 30,
        required: true,
        placeholderKey: "userProfile.fields.firstNameField",
        type: "text",
        initial: "",
    },
    lastName: {
        min: 2,
        max: 30,
        required: true,
        placeholderKey: "userProfile.fields.lastNameField",
        type: "text",
        initial: "",
    },
    about: {
        min: 2,
        max: 500,
        required: true,
        placeholderKey: "userProfile.fields.aboutField",
        type: "text",
        initial: "",
    },
    telegram: {
        min: 2,
        max: 100,
        required: false,
        placeholderKey: "userProfile.fields.telegramField",
        type: "text",
        initial: "",
    },
    allowGeo: {
        min: 0,
        max: 1,
        required: true,
        placeholderKey: "userProfile.fields.allowGeoField",
        type: "boolean",
        initial: false,
    },
    phones: {
        min: 1,
        max: 2,
        required: true,
        placeholderKey: "",
        type: "schema",
        schema: phoneInfoFields,
        array: true,
        initial: [InitialPhone, InitialPhone],
    },
    address: {
        min: 0,
        max: 1,
        required: false,
        type: "schema",
        schema: addressFieldsFactory(),
        initial: null,
        placeholderKey: "",
    },
};

export const userProfileSchemaFactory = (t: TFunction) => {
    return schemaFactory(t, userProfileFields);
};
